module.exports = __webpack_public_path__ + "img/emberjslogo.9a736fb7.png";